module.exports = __webpack_public_path__ + "static/media/icon-establishment-parking.98f7995d.svg";